import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-svginteractmodal',
  templateUrl: './svginteractmodal.component.html',
  styleUrls: ['./svginteractmodal.component.scss']
})
export class SvginteractmodalComponent implements AfterViewInit {

  public svgUrlSanitize: any;

  public svgIdList: any;
  public svgDoc;
  @ViewChild("svg") svgElement: ElementRef;
  constructor(public dialogRef: MatDialogRef<SvginteractmodalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _sanitizer: DomSanitizer, private http: HttpClient) {
    console.log(data);


    this.svgUrlSanitize = this._sanitizer.bypassSecurityTrustResourceUrl(this.data.svg.mediaOptions.url)





  }

  loadSVG() {

    this.http.get(this.data.svg.mediaOptions.url, { responseType: 'text' })
      .subscribe(svgText => {
        const parser = new DOMParser();


        const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');

        //  this.svgDoc = svgDoc;
        console.log(svgDoc, document.querySelector('.svgContainer.contentElement'))
        document.querySelector('.svgContainer.contentElement').appendChild(svgDoc.documentElement);

        /*   let defs = svgDoc.querySelector('defs');
   
           const styleEl = svgDoc.createElementNS("http://www.w3.org/2000/svg", "style");
           styleEl.textContent = `
     .highlighted {
       fill: yellow !important;
       stroke: red;
       stroke-width: 2;
     }
   `;
   
           console.log(styleEl)
           defs.appendChild(styleEl);
           */

        this.svgDoc = document.querySelector("svg:not([class])")

        const elementsWithId = this.svgDoc.querySelectorAll('[id]');

        console.log(elementsWithId, document.querySelectorAll('svg'))
        this.svgIdList = Array.from(elementsWithId).map((el: any) => { return { id: el.id, media: this.data.svg.mediaOptions.customDataSVG?.find(v => v.id == el.id)?.media || "" } }).filter(v => v.id.includes("POI_"));
        console.log(this.svgIdList)
        console.log(this.data.folderContent)
      });
  }

  ngAfterViewInit() {
    this.loadSVG();
  }


  getSelectedMedia(val) {


    let res = this.data.svg.mediaOptions.customDataSVG?.filter(v => v.id == val.id)[0]?.media;
    //     console.log(res)

    if (res == undefined)
      return ""
    else
      return res;
    //   console.log(val)
  }

  highlightSVGElement(id) {

    document.querySelectorAll('.highlightedSVG').forEach(el => {
      console.log(el)
      el.classList.remove('highlightedSVG')
    })

    console.log(this.svgDoc.getElementById(id))
    this.svgDoc.getElementById(id).classList.add('highlightedSVG')
  }

  setNewMedia(val, e) {
    console.log(val, this.data.svg);

    if (this.data.svg.mediaOptions) {
      let index = this.data.svg.mediaOptions.customDataSVG?.findIndex(v => v.id == val.id)
      console.log(index)
      if (index != -1 && index != undefined) {
        console.log(index, this.data.svg.mediaOptions.customDataSVG, val, e)
        this.data.svg.mediaOptions.customDataSVG[index].media = e.value
      }
      else if (!this.data.svg.mediaOptions.customDataSVG) {
        this.data.svg.mediaOptions.customDataSVG = []
        this.data.svg.mediaOptions.customDataSVG.push(val)
      }

      else
        this.data.svg.mediaOptions.customDataSVG.push({ id: val.id, media: e.value })

    }

  }

}
